__webpack_require__.p = "/2048-game/";